// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__BbmGV","slider_wrap":"Slider_slider_wrap__Kwl5r","slider_item":"Slider_slider_item__tqshz","img_wrap":"Slider_img_wrap__kABGc"};